import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper/core'
import { getAdditionalRecommendFacilities } from '../../../api/common/additional_recommend_facilities'

export default class extends Controller {
  static targets = ['recommendCarousel', 'recommendCarouselList', 'checkboxes']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    const addressNextButton = document.getElementById('address-next-button')
    addressNextButton.addEventListener('click', this.recommendFacilities.bind(this))
  }

  getRecommendFacilityParams () {
    const selectedPrefectureId = document.getElementById('inquiry_prefecture_id').value
    const selectedCityId = document.getElementById('inquiry_city_id').value
    const tourOfFacility = document.querySelector("input[name='inquiry[inquiry_facilities_attributes][0][tour_of_facility]']").checked

    let params = {}

    const recommendParams = JSON.parse(this.recommendCarouselTarget.dataset.recommendParams)
    const {
      inquiryFacilityIds,
      favoriteFacilityIds,
      prefectureIds,
      categoryIds,
      standardMonthlyFee,
      sortByPopularity,
      docSize,
    } = recommendParams

    this.inquiryFacilitiesCount = inquiryFacilityIds.length

    if (favoriteFacilityIds && docSize) {
      // ユーザーがお気に入りに追加した施設のparams
      params = {
        inquiry_facility_ids: inquiryFacilityIds,
        facility_ids: favoriteFacilityIds,
        doc_size: docSize,
        tour_of_facility_inquiry: tourOfFacility,
      }
    } else if (prefectureIds && categoryIds) {
      // お問い合わせされた施設に条件が近い施設のparams
      params = {
        inquiry_facility_ids: inquiryFacilityIds,
        prefecture_ids: prefectureIds,
        category_ids: categoryIds,
        standard_monthly_fee: Number(standardMonthlyFee),
        selected_city_id: selectedCityId,
        tour_of_facility_inquiry: tourOfFacility,
      }
    } else if (sortByPopularity) {
      // 同じエリアの人気施設のparams
      params = {
        inquiry_facility_ids: inquiryFacilityIds,
        sort_by_popularity: sortByPopularity,
        prefecture_ids: [selectedPrefectureId],
        selected_city_id: selectedCityId,
        tour_of_facility_inquiry: tourOfFacility,
      }
    } else {
      params = null
    }

    return params
  }

  recommendFacilities (e) {
    getAdditionalRecommendFacilities(this.getRecommendFacilityParams()).then((data) => {
      console.log('recommend success')
      if (data.results.length > 0) {
        this.appendRecommendCarousel(data.results, this.recommendCarouselTarget, this.recommendCarouselListTarget)
        // このコンポーネント下のチェックボックスにだけイベントを追加する
        this.checkboxesTargets.forEach((checkbox) => {
          checkbox.addEventListener('change', this.inquiryLimitExcessJudgment.bind(this))
        })
      } else {
        this.hideRecommendCarousel()
      }
    })
  }

  inquiryLimitExcessJudgment () {
    const limitSize = (20 - this.inquiryFacilitiesCount)
    console.log(limitSize)
    if (this.countCheckedBoxes() >= limitSize) {
      this.changeCheckboxesDisabled(true)
      alert('21件以上は、まとめてお問い合わせできません。')
    } else {
      this.changeCheckboxesDisabled(false)
    }
  }

  changeCheckboxesDisabled (boolean) {
    const checkboxes = document.querySelectorAll('input[name="inquiry[recommend_facility_ids][]"]')
    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        checkbox.disabled = boolean
      }
    })
  }

  countCheckedBoxes () {
    let checkedCount = 0
    document.querySelectorAll('input[name="inquiry[recommend_facility_ids][]"]').forEach((checkbox) => {
      if (checkbox.checked) {
        checkedCount++
      }
    })
    return checkedCount
  }

  fee (value) {
    return Math.round(value / 10000)
  }

  appendRecommendCarousel (results, carouselTarget, slideTarget) {
    // 住所を入れ直して再検索をかけた際に、非表示化されているコンテナを再表示させる
    carouselTarget.parentNode.classList.remove(`${this.className}::hidden-container`)
    slideTarget.innerHTML = ''
    const keyword = this.recommendCarouselTarget.dataset.keyword

    results.forEach((result) => {
      let admissionFee = ''
      let monthlyFee = ''
      let cost = ''
      let photo = ''
      let reviews = ''
      let vacancies = ''
      let info = ''
      const stations = []
      const labels = []

      if (result.low_admission_fee_total != null && result.high_admission_fee_total != null) {
        if (result.low_admission_fee_total === result.high_admission_fee_total) {
          admissionFee = `
          <div class="${this.className}::recommend-form-slide__cost-fee">
            <span class="${this.className}::recommend-form-slide__cost-heading">入居金</span>
            <span class="${this.className}::recommend-form-slide__cost-value"><em>${this.fee(result.low_admission_fee_total)}</em>万円</span>
          </div>`
        } else {
          admissionFee = `
          <div class="${this.className}::recommend-form-slide__cost-fee">
            <span class="${this.className}::recommend-form-slide__cost-heading">入居金</span>
            <span class="${this.className}::recommend-form-slide__cost-value"><em>${this.fee(result.low_admission_fee_total)}</em><span>〜</span><em>${this.fee(result.high_admission_fee_total)}</em>万円</span>
          </div>`
        }
      }

      if (result.low_monthly_fee_total != null && result.high_monthly_fee_total != null) {
        if (result.low_monthly_fee_total === result.high_monthly_fee_total) {
          monthlyFee = `
          <div class="${this.className}::recommend-form-slide__cost-fee">
            <span class="${this.className}::recommend-form-slide__cost-heading">月額</span>
            <span class="${this.className}::recommend-form-slide__cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em>万円</span>
          </div>`
        } else {
          monthlyFee = `
          <div class="${this.className}::recommend-form-slide__cost-fee">
            <span class="${this.className}::recommend-form-slide__cost-heading">月額</span>
            <span class="${this.className}::recommend-form-slide__cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em><span>〜</span><em>${this.fee(result.high_monthly_fee_total)}</em>万円</span>
          </div>`
        }
      }

      if (admissionFee || monthlyFee) {
        cost = `<div class="${this.className}::recommend-form-slide__cost">${admissionFee + monthlyFee}</div>`
      }

      if (result.facility_image_url) {
        photo = `
        <a class="${this.className}::recommend-form-slide__photo" href="${result.facility_url}" target="_blank" rel="noopener noreferrer">
          <img loading="lazy" alt="" width="176" height="176" src="${result.facility_image_url}">
        </a>`
      }

      if (result.reviews_count != null) {
        reviews = `<dl class="${this.className}::recommend-form-slide__reviews"><dt>口コミ</dt><dd>口コミ<em>${result.reviews_count}</em>件</dd></dl>`
      }

      if (result.is_vacancy_displayable && result.vacancies_total != null) {
        vacancies = `<dl class="${this.className}::diagnose-form-slide__vacancies"><dt>空室</dt><dd>${result.vacancies_total}</dd></dl>`
      }

      if (photo || cost || (stations.length > 0)) {
        info = `
        <div class="${this.className}::recommend-form-slide__info">
          ${photo}
          <div class="${this.className}::recommend-form-slide__info-text">
            ${cost}
            <div class="${this.className}::recommend-form-slide__stations">${stations.join('')}</div>
          </div>
        </div>`
      }

      result.near_stations.forEach(station => {
        stations.push(`<div class="${this.className}::recommend-form-slide__station"><a href="${station.station_url}" target="_blank" rel="noopener noreferrer">${station.station_name}</a>から 徒歩${station.walking_time}分</div>`)
      })

      result.supported_care_level_labels.forEach(label => {
        const className = label.existence ? `${this.className}::recommend-form-slide__label--exist` : ''
        labels.push(`<li class="${this.className}::recommend-form-slide__label ${className}">${label.name}</li>`)
      })

      const content = `
      <div class="${this.className}::recommend-form-slide swiper-slide">
        <div class="${this.className}::recommend-form-slide__container">
          <div class="${this.className}::recommend-form-slide__heading">
            <a href="${result.facility_url}" target="_blank" rel="noopener noreferrer">${result.facility_name}</a>
          </div>
          <div class="${this.className}::recommend-form-slide__content">
            <div class="${this.className}::recommend-form-slide__reviews-and-vacancies">${reviews + vacancies}</div>
            ${info}
          </div>
          <ul class="${this.className}::recommend-form-slide__labels">${labels.join('')}</ul>
          <div class="${this.className}::recommend-form-slide__checkbox-container">
            <label class="${this.className}::recommend-form-slide__checkbox">
              <input
                type="checkbox"
                value="${result.facility_id}"
                name="inquiry[recommend_facility_ids][]"
                data-inquiry--consultation--recommend--facilities--component-target="checkboxes">
              <i></i>
              <span class="${this.className}::recommend-form-slide__checkbox-text">この施設も一緒に問い合わせる</span>
            </label>
          </div>
        </div>
      </div>
    `

      slideTarget.insertAdjacentHTML('beforeend', content)
    })

    const swiper = new Swiper(carouselTarget, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      lazyLoading: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        prevEl: `#${keyword}_carousel_prev`,
        nextEl: `#${keyword}_carousel_next`,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: `${this.className}::bullet`,
        bulletActiveClass: `${this.className}::bullet-active`,
      },
    })

    swiper.enable()
  }

  hideRecommendCarousel () {
    this.recommendCarouselTarget.parentNode.classList.add(`${this.className}::hidden-container`)
  }
}
